module.exports = __webpack_public_path__ + "static/media/Opioid-M-One-09D.22e27af4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/Opioid-M-One-09D.mp3
// module id = 577
// module chunks = 0